export const links = [
  {
    href: 'https://hudd.no/auth',
    labelKey: 'auth.logIn',
    variant: 'primary',
  },
  {
    href: 'https://hudd.no/auth',
    labelKey: 'auth.createAccount',
    variant: 'secondary',
  },
];
